module.exports = __webpack_public_path__ + "static/media/wallpad-dialog-box.60413383.png";